import * as jQuery from "jquery";
const moment = require("moment");
import { ILogEntry } from "motw_core/Entity/ILogEntry";
import SoundManager from "source/app/services/Sound/SoundManager";
import * as toastr from "toastr";
import { IsMobileDevice } from "../../domain/Device/Helpers/IsMobile";
import { Or } from "../../domain/Or";
import { IToolsState } from "../../presentation/Header/Tools/ToolsState";
import VerbConstants from "motw_core/Constants/VerbConstants";
import Intervals from "../Intervals";
import Maths from "../Maths";
import Time from "source/app/services/Time/Time";
import { ESharedComponent } from "./State/ESharedComponent";
import { State } from "./State/State";
import { DisplayToastrError } from "source/app/presentation/Shared/HandleError";
import { Sounds } from "../Sound/Sounds";
import HowlAudioProvider from "../Sound/AudioProvider/HowlAudioProvider";
const cashJS = require("cash-dom");

export const UI = {
    ToggleAnimations() {
        const isEnabled = State.ReadClass<IToolsState>(ESharedComponent.Tools)
            .state.enableAnimations;
        const newAnimationState = !isEnabled;
        // UI.SetAnimations(newAnimationState);
        State.ReadClass<IToolsState>(ESharedComponent.Tools).setState({
            enableAnimations: newAnimationState,
        });
    },

    Timer: (function () {
        const Reset = () => {
            const state = State.ReadClass<IToolsState>(
                ESharedComponent.Tools
            ).state;
            const timerInterval = Intervals.Get().find(
                (interval) => interval.name === "countdownTimer"
            );
            if (timerInterval) Intervals.Stop("countdownTimer");
            if (state.timerHowl !== undefined) state.timerHowl.unload();
            State.ReadClass<IToolsState>(ESharedComponent.Tools).setState({
                timeLeft: 0,
                timerHowl: undefined,
            });

            // Sounds.tableBell.Play();
        };

        const Countdown = () => {
            var timeLeft = State.ReadClass<IToolsState>(ESharedComponent.Tools)
                .state.timeLeft;
            if (timeLeft === 0) {
                Reset();
                return;
            }

            State.ReadClass<IToolsState>(ESharedComponent.Tools).setState({
                timeLeft: timeLeft - 1,
            });
        };

        return {
            Reset,
            Countdown,
        };
    })(),

    GetChartData: (log: ILogEntry[]) => {
        if (!log) throw new Error("missing log data!");
        if (log.length <= 1) return;

        const firstDate = moment(log[0].lastmodifiedtime)
            .local()
            .format("YYYY-MM-DD");

        const lastDate = moment(log[log.length - 1].lastmodifiedtime)
            .local()
            .format("YYYY-MM-DD");

        return Time.GetDatesBetween(firstDate, lastDate).map((date) => {
            return {
                Date: date,
                TotalKips: Maths.GetTotalKipsOnDate(log, date),
            };
        });
    },

    IncrementKips: function (increment: number) {
        if (!increment) throw new Error("No increment value provided!");

        const inputKips = cashJS("#inpKips");
        let currentValue = +inputKips.val();
        if (!currentValue) currentValue = 0;
        const newValue = currentValue + increment;
        inputKips.val(String(newValue));
    },

    GetEntrySignificance: (entry: string) => entry.indexOf(" "),

    IsValid: (function () {
        const NewEntryCategory = (lastEntry: string, newEntry: string) => {
            if (!lastEntry || !newEntry)
                throw new Error("Missing input value(s)!");

            var lastEventCategory = UI.GetEventCategory(lastEntry);
            var currentEventCategory = UI.GetEventCategory(newEntry);

            if (lastEventCategory === currentEventCategory) {
                DisplayToastrError(
                    "The new entry's category cannot be the same as the last one",
                    "Whoops"
                );

                return false;
            }
            return true;
        };

        // This validation is not being used
        const NewEntryTime = (lastEntryTime: number) => {
            if (!lastEntryTime) throw new Error("Missing last entry time!");

            const lastEntrySecondsAgo =
                (new Date().getTime() - lastEntryTime) / 600;
            const secondsBeforeNewEntry = 300;
            if (lastEntrySecondsAgo < secondsBeforeNewEntry) {
                var secondsLeft = Math.ceil(
                    secondsBeforeNewEntry - lastEntrySecondsAgo
                );
                DisplayToastrError(
                    "You have to wait " +
                        Time.FormatSeconds(secondsLeft) +
                        " before making another entry",
                    "Not so fast!"
                );
                return false;
            }
            return true;
        };

        return {
            NewEntryCategory,
            NewEntryTime,
        };
    })(),

    IsEventVerbValid: (eventText: string) => {
        if (eventText === undefined) return false;

        var eventCategory = UI.GetEventCategory(eventText);
        var eventVerb = UI.GetEventVerb(eventText);

        var isValid =
            VerbConstants.Verbs.Get(eventCategory).filter(
                (verb) => verb === eventVerb
            ).length > 0;

        return isValid;
    },

    GetEventVerb: (eventText: string) => {
        if (eventText === undefined) return false;
        let verbWordIndex = 1;
        // if (UI.GetEventCategory(eventText) === false) verbWordIndex = 0;
        var eventVerb = eventText.split(/\s+/)[verbWordIndex]; // Get first word in event text
        return eventVerb;
    },

    GetValidVerbs: (eventText: string) => {
        if (eventText === undefined) return false;
        var eventCategory = UI.GetEventCategory(eventText);
        var validVerbs = VerbConstants.Verbs.Get(eventCategory);
        return validVerbs.join(", ");
    },

    GetEventCategory: (eventText: string) => {
        var entrySignificance = eventText.indexOf(" ");
        if (entrySignificance > 3 || entrySignificance < 0) {
            throw new Error("Invalid event category");
        }

        var eventCategory = eventText[0];
        return eventCategory;
    },

    GetTimeGreeting: (hour: number) => {
        if (hour === undefined || isNaN(hour) === true)
            throw new Error("Cannot read hour " + hour);
        if (hour >= 0 && hour < 6) return "Good evening!";
        if (hour >= 6 && hour < 12) return "Good morning!";
        if (hour >= 12 && hour < 17) return "Good afternoon!";
        if (hour >= 17 && hour < 24) return "Good evening!";
    },

    GetCoreStatisticColor: (value: number) => {
        if (value === undefined || isNaN(value) === true)
            throw new Error("Cannot parse value " + value);

        if (value > 100)
            throw new Error("Value " + value + " cannot be greater than 100");

        if (value >= 0 && value < 60) return "red";
        if (value >= 60 && value < 80) return "orange";
        if (value >= 80 && value <= 100) return "darkseagreen";
    },

    GetMoodColor: (currentMood: number) => {
        if (currentMood === undefined || isNaN(currentMood))
            throw new Error("Unable to parse currentMood value!");
        if (currentMood === 2) return "#868df1";
        if (currentMood === 1) return "#a1e990";
        if (currentMood === 0) return "#dedede";
        if (currentMood === -1) return "#ffa500";
        if (currentMood === -2) return "#ff5757";
        throw new Error("No color found for mood value " + currentMood);
    },

    GetMoodDescription: (mood: number) => {
        if (mood === undefined || isNaN(mood))
            throw new Error("Unable to parse mood value!");
        if (mood === 2) return "Flying";
        if (mood === 1) return "Playing";
        if (mood === 0) return "Waiting";
        if (mood === -1) return "Stop!";
        if (mood === -2) return "Escape!";
        throw new Error("No description found for mood value " + mood);
    },

    GetMoodIcon: (mood: number) => {
        if (mood === undefined || isNaN(mood))
            throw new Error("Unable to parse mood value!");
        if (mood === 2) return "ra-feather-wing";
        if (mood === 1) return "ra-dragon";
        if (mood === 0) return "ra-sea-serpent";
        if (mood === -1) return "ra-bird-claw";
        if (mood === -2) return "ra-maggot";
        throw new Error("No icon found for mood value " + mood);
    },

    DarkenBackground: (opacity: string) => {
        let opacityValue = parseFloat(parseFloat(opacity).toFixed(2));
        if (opacityValue > 0.9) opacityValue = 0.9;
        if (opacityValue < 0.1) opacityValue = 0.1;
        var newImageCSS = cashJS("html")!
            .css("background")!
            .replace(
                /rgba\(0, 0, 0, 0\.[0-9]*\)/g,
                "rgba(0, 0, 0, " + opacityValue + ")"
            );
        cashJS("html").css("background", newImageCSS);
    },

    GetMoodBackgroundOpacity: (mood: string) => {
        const backgroundOpacity = 0.6 - (parseInt(mood) / 10) * 1.5;
        return backgroundOpacity;
    },

    GetDriveColorFromCountValue: (value: number) => {
        if (value === undefined || isNaN(value))
            throw new Error("Cannot parse value " + value);
        if (value <= 3) return "lightgray";
        if (value >= 4 && value <= 6) return "lightgreen";
        if (value >= 7) return "crimson";
    },

    GetDriveColorFromPercentValue: (value: number) => {
        if (value === undefined || value < 0 || isNaN(value) === true)
            throw new Error("Cannot parse value " + value);
        if (value >= 0 && value <= 40) return "darkgray";
        if (value >= 40 && value < 80) return "lightgray";
        if (value >= 80) return "lightgreen";
    },

    GetColorForLowDrive: (value: number) => {
        if (value == 0) return "darkgray";
        return "lightgreen";
    },

    GetColorFromString: (str: string) => {
        if (!str) throw new Error("Cannot parse text " + str);
        var hash = 0;
        for (var i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }
        var colour = "#";
        for (i = 0; i < 3; i++) {
            var value = (hash >> (i * 8)) & 0xff;
            colour += ("00" + value.toString(16)).substr(-2);
        }
        return colour;
    },

    GetDriveColorFromSymbol: (symbol: string) => {
        if (!symbol) throw new Error("symbol missing");
        if (symbol === "^") return "#FFFF00";
        if (symbol === "+") return "#87CEFA";
        if (symbol === "*") return "#90EE90";
        if (symbol === ".") return "#FF0000";
        if (symbol === "#") return "#F08080";
        if (symbol === "<") return "#bbff1e";
        if (symbol === ">") return "#00b6ff";
        if (symbol === "/") return "#4286f4";
        if (symbol === "\\") return "#9b1d9b";
        if (symbol === "_") return "#b3a1f7";
        throw new Error("Cannot find color for given symbol " + symbol);
    },

    GetLogEntryBackgroundColor: (entry: string, opacity: number) => {
        if (!entry) throw new Error("Entry missing!");
        if (!opacity) opacity = 1.0;
        const eventCategory = UI.GetEventCategory(entry);
        var rgbaColor = Maths.ConvertHexToRgbA(
            UI.GetDriveColorFromSymbol(eventCategory),
            opacity
        );
        return rgbaColor;
    },

    GetHabitColorFromStatus: (status: string) => {
        if (!status) throw new Error("status missing");
        if (status === "Active") return "orange";
        if (status === "Habit") return "lightgreen";
        if (status === "Wait") return "darkgray";
        throw new Error("Cannot find color for given status " + status);
    },

    GetRandomYellowColor() {
        const randomLightness = 70 + Maths.GetSingleRandomNumber(30);
        return "hsla(45, 100%, " + randomLightness + "%, 1)";
    },

    ScrollToDiv: (
        target: string,
        extraTopOffset?: number,
        container?: string
    ) => {
        const targetOffset = jQuery(target).offset();

        if (!targetOffset) {
            return;
        }

        const topOffset =
            targetOffset.top - scrollOffset + Or(extraTopOffset, 0);

        window.scroll({
            top: target === "#pnlTitle" ? 0 : topOffset,
            behavior: IsMobileDevice() ? "auto" : "smooth",
        });
    },

    ScrollToTop: () => {
        window.scroll({
            top: 0,
            behavior: IsMobileDevice() ? "auto" : "smooth",
        });
    },

    ScrollToFirst: (selector: string) => {
        const firstElement = document.querySelector<HTMLElement>(selector);

        if (!firstElement) {
            return;
        }

        window.scroll({
            top:
                firstElement.getBoundingClientRect().top +
                window.scrollY -
                scrollOffset,
            behavior: IsMobileDevice() ? "auto" : "smooth",
        });
    },

    ScrollToLast: (selector: string) => {
        const elements = document.querySelectorAll<HTMLElement>(selector);
        const lastElement = elements[elements.length - 1];

        if (!lastElement) {
            return;
        }

        window.scroll({
            top:
                lastElement.getBoundingClientRect().top +
                window.scrollY -
                scrollOffset,
            behavior: IsMobileDevice() ? "auto" : "smooth",
        });
    },

    FocusOnElement: (elementName: string) => {
        document.getElementById(elementName)?.focus();
    },

    GetWeatherIcon: (ambienceName: string) => {
        if (!ambienceName) throw new Error("Missing ambience name property");

        const mapAmbienceToIcon = [
            { name: "City", icon: "☁" },
            { name: "Night Driving", icon: "☾" },
            { name: "Airplane", icon: "☾" },
            { name: "River", icon: "☂" },
            { name: "Rainstorm", icon: "☂" },
            { name: "Woodlands", icon: "☀" },
            { name: "Hall", icon: "☁" },
            { name: "Cafe", icon: "☀" },
            { name: "Food Court", icon: "☁" },
            { name: "Patio", icon: "☀" },
        ];

        const ambience = mapAmbienceToIcon.find(
            (ambience) => ambience.name === ambienceName
        );
        if (!ambience)
            throw new Error(
                "Cannot find value for ambienceName " + ambienceName
            );
        return ambience.icon;
    },
};

export default UI;

const scrollOffset = 80;

export function ScrollToBottomIfLarge(targetElementName: string) {
    const element: any = document.getElementById(targetElementName)!;

    if (element === null) {
        return;
    }

    const elementHeight = element.offsetHeight;
    const windowHeight = window.innerHeight;
    const scrollY = window.scrollY;

    if (elementHeight < windowHeight - 100) {
        return;
    }

    const scrollBy = elementHeight - 250 - scrollY;
    window.scrollBy(0, scrollBy);
}

export function IsLargeElement(targetElementName: string) {
    const element: any = document.getElementById(targetElementName)!;

    if (element === null) {
        return;
    }

    const elementHeight = element.offsetHeight;
    const windowHeight = window.innerHeight;

    const isSmallElement = elementHeight < windowHeight - 100;
    return !isSmallElement;
}
